import request from '@/utils/request'
//微信扫码预约核销
export function writeOff(data) {
  return request({
    url: '/sys/appointmentSacrifice/use',
    method: 'post',
    data
  })
}